// extracted by mini-css-extract-plugin
export default {"auctionPageContainer":"AuctionPage_auctionPageContainer__UR8F-"};